import { RMAItem } from "./RMAItem";

export class RMAResponse {
  constructor() {
    this.RMANumber = "";
    this.Action = "";
    this.CustomerResponse = "";
    this.TakenByEmail = "";
    this.PONumber = "";
    this.RMAResponseID = "00000000-0000-0000-0000-000000000000";
  }

  public RMANumber: string;
  public RMAResponseID: string;
  public RMAItemRowPointer: string;
  public Action: string;
  public CustomerResponse: string;
  public TakenByEmail: string;
  public UserID: string;
  public DateSubmitted: Date;
  public RMAItem: RMAItem;
  public POFile: File;
  public POFileName: string;
  public PONumber: string;
}
